import { t } from '@mp/locale';
var currentLang = "en";
export function setLanguage(lang) {
    currentLang = lang;
}
export var propertyTypes = {
    RESIDENTIAL: t("CAPTURE_SERVICES.PROPERTY_TYPES.RESIDENTIAL"),
    COMMERCIAL: t("CAPTURE_SERVICES.PROPERTY_TYPES.COMMERCIAL"),
};
export var unitSizeLabels = {
    SQUARE_METER: t("CAPTURE_SERVICES.SIZE_UNIT_SHORT_LABELS.SQUARE_METER"),
    SQUARE_FT: t("CAPTURE_SERVICES.SIZE_UNIT_SHORT_LABELS.SQUARE_FT"),
};
export function getCurrencySymbol(customer_currency) {
    switch (customer_currency) {
        case "USD":
            return "$";
        case "GBP":
            return "£";
        case "EUR":
            return "€";
        case "JPY":
            return "¥";
    }
}
export function formatPreferredStartTime(startTime, timeZone, options) {
    var date = startTime.toLocaleDateString(currentLang, {
        weekday: (options === null || options === void 0 ? void 0 : options.longDay) ? "long" : "short",
        month: "short",
        day: "numeric",
        timeZone: timeZone,
    });
    var time = startTime.toLocaleTimeString(currentLang, {
        hour: "numeric",
        minute: "numeric",
        timeZone: timeZone,
    });
    var timezone = new Intl.DateTimeFormat(currentLang, {
        timeZone: timeZone,
        timeZoneName: "short",
    })
        .format(startTime)
        .split(" ")[1];
    return t("CAPTURE_SERVICES.SCHEDULER.formattedDateTime", null, {
        date: date,
        time: time,
        timezone: timezone,
    });
}
export function getDuration(totalMinutes) {
    var hours = Math.floor(totalMinutes / 60);
    var minutes = totalMinutes % 60;
    if (!totalMinutes) {
        return "0";
    }
    if (hours < 2) {
        return t("CAPTURE_SERVICES.ORDER.SCHEDULE.duration.minutes", null, {
            minutes: totalMinutes,
        });
    }
    if (!minutes) {
        return t("CAPTURE_SERVICES.ORDER.SCHEDULE.duration.hours", null, { hours: hours });
    }
    return t("CAPTURE_SERVICES.ORDER.SCHEDULE.duration.hoursAndMinutes", null, {
        hours: hours,
        minutes: minutes,
    });
}
